import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["row"]

  connect() {
    this.setCursor()
  }

  // private
  setCursor(){
    this.rowTargets.forEach(row => {
      const hasLink = row.dataset.tableHeaderComponentUrlParam

      row.querySelectorAll("td").forEach(cell => {
        const isClickable = !cell.classList.contains("unclickable")
        if(hasLink && isClickable) {
          cell.style.cursor = "pointer"
        }
      })
    })
  }

  redirect(event){
    const isLeftClick = event.button === 0
    const isMiddleClick = event.button === 1
    const isCtrlClick = event.ctrlKey || event.metaKey && isLeftClick
    const isValidClick = isLeftClick || isMiddleClick || isCtrlClick

    const isActionCell = event.target.closest("td").classList.contains("actions-cell")
    const isExcludeCell = event.target.closest("td").classList.contains("unclickable")
    const url = event.params.url

    if (url && !isActionCell && !isExcludeCell && isValidClick) {
      if (isLeftClick && event.params.turbo) {
        fetch(url, {
          method: "GET",
          headers: {
            Accept: "text/vnd.turbo-stream.html",
            "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
          }
        })
          .then(r => r.text())
          .then(html => Turbo.renderStreamMessage(html))
          .catch(error => {});
      } else {
        const target = isMiddleClick || isCtrlClick ? "_blank" : event.params.target
        window.open(event.params.url, target)
      }
    }
  }
}
